module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8oAdf3/tc-custom/9781488067488.jpg?1708088025454",
      "alt": "This image is the cover for the book Badlands Beware, The Badlands Cops Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Badlands Beware, The Badlands Cops Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A small town cop puts a local schoolteacher under his protection when her father goes missing in this romantic suspense.")]), _c('br'), _c('br'), _vm._v("The truth might hurt them both."), _c('br'), _c('br'), _vm._v("When Detective Tucker Wyatt is sent to protect Rachel Knight from her father’s enemies, neither of them realizes exactly how much danger she’s in. As she starts making connections between her father’s past and a current disappearance, she’s suddenly under attack from all sides. But Rachel and Tucker will not back down. They’ll do whatever it takes to solve the open case, even if it means putting their lives at risk.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicole Helm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicole Helm writes down-to-earth contemporary romance and fast-paced romantic suspense. She lives with her husband and two sons in Missouri. Visit her website: www.nicolehelm.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0